<template>
    <v-container v-if="this.zamawiajacy" class="page">
  <table>
    <thead>
    <tr><td>
  
  <div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
    <div class="left-cointainer">
      <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
    </div>
    <div class="right-cointainer">
      Tutore Poland Sp. z o.o.<br>
      ul. Piotrkowska 157A, 90-440 Łódź<br>
      NIP: 7272812193
    </div>
  </div>
  
    </td></tr>
    </thead>
  <tbody>
  <tr><td>
  
  <p align="center" style="margin-top:20px;">
      <strong>COOPERATION AGREEMENT</strong>
  </p>
  <p>
    Concluded in Łódź between:
  </p>
  <p><strong>The Principal:</strong></p>
  <p>
    <strong>Tutore Poland Sp. z o.o.</strong>, based in Łódź at Piotrkowska Street 157A, 90-440 Łódź, entered in the Register of Entrepreneurs of the National Court Register kept by the District Court for Łódź-Śródmieście in Łódź, XX Division of the National Court Register under the number KRS: 0000670834, NIP: 727-28-12- 193, REGON: 366891567, represented by: {{ zamawiajacy }}, hereinafter referred to as <strong>the Principal,</strong>
  </p>
  <p>and</p>
    <strong>the Contractor:</strong>
    <br/>
    Ms./Ms.
    <br/>
    Name: <strong>{{ imieNazwisko }}</strong>
    <br/>
    PESEL: <strong>{{ pesel }}</strong>
    <br/>
    Address of residenc: <strong>{{ zamieszkany }}</strong>
    <br/>
    Telephone number: <strong>{{ nrTelefonu }}</strong>
    <br/>
    E-mail: <strong>{{ email }}</strong>
    <br/>
    Bank account number: <strong>{{ kontoBankowe }}</strong>
    <br/>
    <br/>
  
    conducting business activity under the company:
    <br/>
    Company Name: <strong>{{ nazwaFirmy }}</strong>
    <br/>
    Registered office: <strong>{{ siedzibaFirmy }}</strong>
    <br/>
    NIP: <strong>{{ nip }}</strong>
    <br/>
    <br/>
  
    <p>hereinafter jointly referred to as <strong>the Parties</strong> with the following content:</p>
  
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 1 Subject matter of the agreement</strong>
  </p>
  <p style="margin-bottom: 0px;">The Principal commissions and the Contractor undertakes to perform for the Principal's benefit, for remuneration, such activities as:
  </p>
  <ol>
    <li>reliable preparation and conduct of remote or on-site classes for all participants of courses organized by the Principal following the educational program indicated by the Principal and the schedule of classes. The schedule may be in the form of an electronic file;</li>
    <li>reliable maintenance of documentation confirming the realization of classes, including, in particular: course logs, attendance lists, documentation of students' evaluation, and reports on the realization of classes - in the form and at the dates established by the Principal;</li>
    <li>timely execution of all organizational guidelines of the Principal within the deadlines set by the Principal;</li>
    <li>conducting de-briefing classes;</li>
    <li>taking care of the proper condition of the Principal's property and neatness and order in the place of execution of the assignment;</li>
    <li>cooperating with the Principal's designees, whereby the Contractor shall regularly and promptly (at the end of each working day at the latest) read the messages sent by these persons via e-mail, SMS messages, or instant messaging and respond to the information as soon as possible if necessary, including in particular:
      <ol type="a">
        <li>providing necessary information to the extent specified in the situation,</li>
        <li>participating in meetings, visit interviews, and evaluations;</li>
      </ol>
    </li>
    <li>cooperation with students or, in the case of underage students, their parents or legal guardians, including, in particular, providing the necessary information regarding the service (e.g., handing over homework, checking and submitting reports on students' progress) - participation in meetings or gatherings, within the strict deadlines set by the Principal;</li>
    <li>other tasks and projects ordered by the Principal.</li>
  </ol>
  <p>To ensure the conditions for the execution of this Agreement, the Principal undertakes to make available the teaching materials currently in his possession. The above does not include electronic equipment (computer, sound equipment, etc.), which the Contractor shall arrange at its own expense.</p>
  
  <p align="center" style="margin-bottom: 0px; margin-top: 10px;">
    <strong>§ 2 Performance of the contract</strong>
  </p>
  <ol>
    <li>The Contractor undertakes to perform the subject of this agreement with due diligence.</li>
    <li>The performance of the subject of the agreement indicated in § 1 will be carried out online via platforms provided by the Principal or in the stationary formula at the selected facility of the Principal. The form of conducting classes will be specified in the schedule of classes. Principal shall allow the Contractor to use the platforms necessary to conduct classes.</li>
    <li>The parties agree that 60 minutes of classes according to the agreed schedule shall be considered as the teaching unit.</li>
    <li>The total amount of teaching hours to be performed shall be specified in the schedule each time by the Principal in advance and summarized at the end of each calendar month.</li>
    <li>The parties shall allow changing the dates and hours of teaching specified in the schedule only by mutual agreement.</li>
    <li>The Contractor shall perform the services covered by this agreement under conditions of complete independence from the Principal. In particular, the Principal shall not be entitled to exercise any managerial rights over the Contractor without interfering with the organization and/or discipline of the Contractor's work.</li>
    <li>Any technical or methodological problems concerning the entirety of the activities entrusted to the Contractor shall be resolved by mutual agreement of the Parties, respecting the independence of the professional activities carried out by the Contractor.</li>
  </ol>
  <br>
  
  <p align="center" style="margin-bottom: 0px; margin-top: 10px;">
    <strong>§ 3 Conditions for the provision of services</strong>
  </p>
    <ol>
      <li>the Contractor, undertakes to duly provide services, in particular to:
          <ol type="a">
              <li>to conduct the classes indicated in §1 under the schedule sent by the Principal or the person designated by the Principal no later than the last day of the month preceding the month in which the order is to be performed;</li>
              <li>to cooperate with the Principal or the person designated by him,</li>
              <li>to reliably maintain documentation confirming the realization of educational activities, including, in particular: course logs, attendance lists, documentation of students' evaluation, and reports on the realization of activities - in the form established by the Principal;</li>
              <li>conducting de-briefing classes;</li>
              <li>maintaining inventory;</li>
              <li>implement the project's objectives for the classes by:
                  <ul>
                      <li>motivating the student to work independently and overcome difficulties,</li>
                      <li>teaching skills necessary for further study,</li>
                      <li>training a research attitude,</li>
                      <li>learning logical thinking,</li>
                      <li>presenting the results of their work;</li>
                  </ul>
              </li>
              <li>to carry out all organizational guidelines of the Principal within the deadlines set by the Principal;</li>
              <li>to provide services in a manner consistent with health and safety regulations and rules;</li>
          </ol>
      </li>
      <li>The Contractor shall diligently prepare and conduct classes according to his own invention based on the Principal's original educational program and under the agreed schedule.</li>
      <li>The Contractor shall be responsible for the quality and timeliness of the conducted classes.</li>
      <li>The Contractor shall bear full responsibility for damage caused by his actions or omissions during the execution of the subject of the contract, in particular, in the event of failure to meet the deadline for the execution of the order, the Contractor shall be liable for damages incurred by the Principal, while in the event of the discovery of errors and defects in the subject of the contract - he shall be obliged to remove them free of charge.</li>
      <li>The Contractor shall promptly inform the Principal of any event</li>
      <li>Preventing him from carrying out the classes according to the schedule.</li>
      <li>The Contractor shall not subcontract the execution of the subject matter of this agreement to third parties.</li>
      <li>Violation of the prohibition referred to in paragraph 6 will result in the third party not being allowed to perform any activities and will not receive any remuneration for it.</li>
    </ol>
  <br>
  
  <p align="center" style="margin-bottom: 0px; margin-top: 5px;">
    <strong>§ 4 Absences and notification</strong>
  </p>
  <ol>
    <li>If the Contractor is unable to conduct the classes specified in § 1 on the dates specified in the schedule for reasons attributable to the Contractor, the Contractor agrees to immediately notify the Principal of this fact, no later than 7 days before the scheduled classes. In such a case, the Principal may appoint a person to replace the Contractor in the performance of the assignment described in this agreement.</li>
    <li>In case of sudden indisposition due to illness or ill health, which occurred suddenly, the Contractor may not keep the 7-day notice period of inability to perform the assignment. The Contractor shall immediately, no later than 4 hours after the occurrence of the event and a minimum of 2 hours before the start of the scheduled classes, notify the Principal of such a situation.</li>
    <li>In the event of failure to conduct classes on schedule and failure to notify the Principal not less than 7 days in advance of the scheduled classes, the Principal may terminate the agreement with immediate effect without notice. In such case, regardless of the possibility of termination, the Principal may also claim a contractual penalty in the amount of PLN 5,000 (in words: five thousand zlotys) from the Contractor for the losses incurred, the Principal may also claim compensation exceeding the value of the reserved contractual penalty. Principal shall be entitled to deduct the contractual penalty from the remuneration due to Contractor, to which Contractor hereby agrees. The above provision does not apply to fortuitous situations that make it impossible to notify the Principal of the impossibility of conducting the class.</li>
    <li>If the Contractor is unable to conduct scheduled classes and the Principal is unable to find a replacement, the Contractor shall be obliged to conduct classes in the number of hours equal to the number of missed classes (the so-called "rescheduled classes", described in § 1.4), on another date agreed upon in writing with the Principal, no later than 14 days from the scheduled date of classes or cessation of the reason for the inability to conduct classes.</li>
  </ol>
  <br>
  
  <p align="center" style="margin-bottom: 0px; margin-top: 10px;">
    <strong>§ 5 Duration</strong>
  </p>
  <ol>
    <li>The parties conclude the contract for a fixed period, i.e. from {{ dataObowiazywaniaUmowy() }} until 31.08.2024.</li>
    <li>The parties may terminate the Agreement with one month's notice, with legal effect at the end of the calendar month, after sending written notice of termination (subject to paragraph 3.). The Contractor's statement shall be in writing under pain of nullity; the Principal's statement may be in both written and documentary form.</li>
    <li>The Principal shall have the right to terminate this Agreement without notice if the Contractor blatantly opposes the provisions of this Agreement, by which the parties mean in particular:
      <ol type="a">
        <li>the Contractor's behavior consisting of failure to perform the obligations outlined in § 1, despite the Principal's prior request to cease violations</li>
        <li>violation by the Contractor of the prohibition of competition,</li>
        <li>disclosure of Confidential Information by the Contractor,</li>
        <li>any other violations of this Agreement.</li>
      </ol>
    </li>
    <li>The Principal's statement of termination of the contract with immediate effect may be made both in writing and in documentary form.</li>
    <li>In the event of termination of the contract, the Contractor undertakes to return the materials provided for the duration of the contract by the Principal within 14 days from the date of termination or expiration of the contract. If the Contractor fails to return the materials within the specified period, the Principal may impose a contractual penalty on the Contractor with the value of the materials received. In addition, the Contractor may be charged shipping costs for returned materials.</li>
  </ol>
  <br>
  
  <p align="center" style="margin-bottom: 0px; margin-top: 10px;">
    <strong>§ 6 Remuneration</strong>
    </p>
  <ol>
      <li>
        The Contractor shall receive remuneration for the proper performance of the classes conducted under the Agreement under the following schedule. The Contractor shall not be entitled to additional remuneration for performing additional activities related to the preparation, organization, and reporting of classes under § 2.3 of this Agreement.
          <br>
          Remuneration will depend on the number of active learners (those who have a binding contract for educational services with the Principal in a given settlement period) in a group and will be settled according to the following table:
          <br>
          <br>
          <br>
          <span>Table 1: rates for lessons in fixed courses</span>
          <table style="border: 1px solid; text-align: left; font-size: 12px; width: 50%;">
              <tbody>
                  <tr>
                      <td style="border: 1px solid; padding: 3px 0 3px 5px;"><b>The gross rate for 1 lesson of a 60-minute course</b></td>
                      <td style="border: 1px solid; padding: 3px 0 3px 5px;"><b>Number of active learners in the group in the billing month</b></td>
                  </tr>
                  <tr>
                      <td style="border: 1px solid; padding: 3px 0 3px 5px;">{{ stawka1 }} {{ stawka1 ? 'PLN' : null }}</td>
                      <td style="border: 1px solid; padding: 3px 0 3px 5px;">1</td>
                  </tr>
                  <tr>
                      <td style="border: 1px solid; padding: 3px 0 3px 5px;">{{ stawka2 }} {{ stawka2 ? 'PLN' : null }}</td>
                      <td style="border: 1px solid; padding: 3px 0 3px 5px;">2-5</td>
                  </tr>
                  <tr>
                      <td style="border: 1px solid; padding: 3px 0 3px 5px;">{{ stawka3 }} {{ stawka3 ? 'PLN' : null }}</td>
                      <td style="border: 1px solid; padding: 3px 0 3px 5px;">6 and more</td>
                  </tr>
              </tbody>
          </table>
  
          <div style="page-break-before: always;">
          <span>Table 2: rates for demonstration lessons</span>
          <table style="border: 1px solid; text-align: left; font-size: 12px; width: 75%;">
              <tbody>
                  <tr>
                      <td style="border: 1px solid; padding: 3px 0 3px 5px;"><b>The gross rate for 1 demonstration lesson</b></td>
                      <td style="border: 1px solid; padding: 3px 0 3px 5px;"><b>Lesson mode</b></td>
                      <td style="border: 1px solid; padding: 3px 0 3px 5px;"><b>Length of lesson</b></td>
                  </tr>
                  <tr>
                      <td style="border: 1px solid; padding: 3px 0 3px 5px;">PLN 30</td>
                      <td style="border: 1px solid; padding: 3px 0 3px 5px;">online</td>
                      <td style="border: 1px solid; padding: 3px 0 3px 5px;">30 minutes</td>
                  </tr>
                  <tr>
                      <td style="border: 1px solid; padding: 3px 0 3px 5px;">PLN 60</td>
                      <td style="border: 1px solid; padding: 3px 0 3px 5px;">stationary</td>
                      <td style="border: 1px solid; padding: 3px 0 3px 5px;">60 minutes</td>
                  </tr>
              </tbody>
          </table>
          </div>
      </li>
      <li>The parties agree on a monthly billing period for services rendered. The Contractor shall issue a VAT invoice after the end of the billing period.</li>
      <li>Payment of remuneration for each month of services shall be made within 14 days of issuance of the VAT invoice (according to the date indicated in the invoice). The remuneration shall be paid by wire transfer to the bank account number indicated on the invoice issued by the Contractor and accepted by the Principal. The condition for payment of remuneration is the execution of the subject of the contract and sending a report on its execution according to the guidelines of Tutore Poland, as well as issuing and sending an electronic invoice to: ksiegowosc@tutore.eu. The Contractor declares that the bank account indicated on the VAT invoice will be a settlement account used exclusively for settlements on account of his business activity and will be a bank account reported to the electronic register kept by the Head of the National Tax Administration within the so-called "white list of taxpayers" (hereinafter referred to as the "List"), referred to in the Law on Tax on Goods and Services. If before payment, the Principal becomes aware that the bank account is not recorded in the List, the Principal shall be entitled to make payment to the Contractor's bank account indicated in the List, which shall constitute the performance of the Principal's obligation.</li>
      <li>The Contractor shall keep records confirming the implementation of classes in a given month, in particular, activity logs and attendance lists of students
      </li>
      <li>The documentation referred to in § 6.5 should be completed no later than the last day of the month for which the Contractor is entitled to remuneration for the provision of services.</li>
  </ol>
  <br>
  
  <p align="center" style="margin-bottom: 0px; margin-top: 10px;">
    <strong>§ 7 Confidential information</strong>
  </p>
  <ol>
    <li>
        By Confidential Information, the parties mean all information provided to the Contractor by the Principal or otherwise obtained by the Contractor in connection with the performance of this Agreement, including technical, technological, organizational, or other information of economic value that relates to the Principal and its business, and, in particular, the teaching materials used by the Contractor, the contact database of the Principal's customers (including customers who have terminated their cooperation with the Principal up to 12 months after the end of the contract), computer systems and other information obtained from the Principal during the performance of the contract.
    </li>
    <li>
        The Contractor agrees that Confidential Information obtained under this agreement shall be kept confidential by the Contractor and used exclusively for the performance of this contract. The Confidential Information shall not be used for any other purpose or disclosed or made available to any third party, in whole or in part. The obligation of confidentiality applies to Confidential Information obtained by the Contractor from the Principal in writing and disclosed to the Contractor orally, visually, electronically, or otherwise. The Contractor agrees to keep the Confidential Information received in confidence and not to disclose it to anyone without the written consent of the Principal.
    </li>
    <li>
        The Contractor, upon the termination of the cooperation of the Parties, or, before its termination - at any request of the Principal - shall be obligated toreturn to the Principal within 3 days all Confidential Information, together with documentation and other media on which it was recorded, as well as, copies ofdocumentation or media containing such Information. The Contractor undertakes to delete from the memory of computers and other devices all received or madematerials in such a way that they cannot be reproduced or used in any form in the future.
    </li>
    <li>
        If the Contractor violates the provisions of the preceding paragraphs, in particular, by disclosing or providing access to materials and Confidential Information in violation of this agreement, the Contractor shall be obligated to pay to the Principal a contractual penalty in the amount of PLN 5,000.00 (in words: five thousand zlotys) for each such violation. Such penalty shall be payable within 14 days from the date of the Principal's submission of a statement charging the Contractor with the contractual penalty. The Principal shall be entitled to deduct the contractual penalty from the Contractor's remuneration, to which the Contractor hereby agrees.
    </li>
    <li>
        If the amount of damage or lost benefits of the Principal resulting from violation by the Contractor's breach of the provisions of this agreement will exceed the amount of the contractual penalty indicated in paragraph 4 of this section, the Principal may claim supplementary damages under the general rules under the Civil Code.
    </li>
    <li>
        The Principal shall also consider any use of the Contractor's teaching materials for the Contractor's private purposes and for teaching purposes of persons who are not the Principal's clients as a violation of the principles described in this agreement.
    </li>
    <li>
        Notwithstanding the expiration or termination of this Agreement, the Contractor's obligations to maintain the confidentiality of Confidential Information shall remain in effect for a period of 5 years from the date of termination or expiration of this Agreement.
    </li>
  </ol>
  <br>
  
  <p align="center" style="margin-bottom: 0px; margin-top: 10px;">
    <strong>§ 8 Prohibition of competition</strong>
  </p>
    <ol>
      <li>The following shall be considered by the Parties as competitive activities within the meaning of this paragraph: offering or providing any educational services by the Contractor in any form to the Principal's customers who have entered into a contract with the Principal no later than the date of expiration of this Agreement.</li>
    <li>Competitive activities shall also be deemed to include:
      <ol>
        <li>provision by the Contractor of work for an entity engaged in competitive activities with the Principal;</li>
        <li>provision of services by the Contractor under any civil law contract for the benefit of an entity engaged in competitive activity concerning the Principal,</li>
        <li>operation by the Contractor of an enterprise conducting business competitive to the Principal, including through a third party,</li>
        <li>being a partner in a company conducting business competitively to the Principal, sitting by the Contractor in the bodies of entities conducting business competitively to the Principal</li>
        <li>acting as an agent, attorney, or proxy of persons conducting business competitive to the Principal.</li>
      </ol>
    </li>
    <li>The Contractor undertakes, during the term of cooperation described in this agreement, not to carry out competitive activities concerning the Principal's activities as defined in paragraphs 1 and 2 above.</li>
    <li>If it is the Customer, who is a current customer of the Principal, himself submits a proposal for cooperation to the Contractor, the Contractor is obliged to inform the Customer of the above-mentioned prohibition of competitive activity and refusal to cooperate, and is obliged to inform the Principal of the situation.</li>
    <li>The Principal reserves the right to check with the Contractor whether the provisions of the above paragraph are duly implemented by the Contractor.</li>
    <li>For each violation of the non-compete provisions of this Agreement, the Principal may charge the Contractor with a contractual penalty in the amount of PLN 20,000 (in words: twenty thousand zlotys). In such a case, the Principal may also claim compensation exceeding the value of the reserved contractual penalty. Principal shall be entitled to deduct the contractual penalty from the remuneration due to Contractor, to which Contractor hereby agrees.</li>
    <li>For refraining from competitive activities described above, the Contractor shall not be entitled to additional remuneration.</li>
    </ol>
    <br>
  
  <p align="center" style="margin-bottom: 0px; margin-top: 10px;">
    <strong>§ 9 Completeness and amendment of the Agreement</strong>
  </p>
  <ol>
    <li>This Agreement shall terminate and supersede all other previous written or oral understandings, agreements, arrangements, and contracts of the Parties to the extent covered herein, which are hereby terminated.</li>
    <li>The Parties declare that, apart from this Agreement, there are no additional arrangements or agreements between them regarding the subject matter of this Agreement.</li>
    <li>Any amendments to this Agreement shall be in writing under pain of nullity.</li>
    <li>Termination of this agreement shall be in writing under pain of nullity. The Principal's statement may also be made in documentary form, which shall be considered as fulfillment of the requirement to make a statement in writing.</li>
  </ol>
  <br>
  
  <p align="center" style="margin-bottom: 0px; margin-top: 10px;">
    <strong>§ 10 Disputes and competent court</strong>
  </p>
  <p style="margin-bottom: 0px;">
    The parties declare that they will use their best efforts to resolve disputes arising from this agreement amicably. In case of disputes that cannot be resolved amicably within 14 days from the date of receipt by the other party of a written request for a such amicable resolution, they shall be submitted to the court of competent jurisdiction for the Principal's seat. The provisions of the preceding sentences are not arbitration clauses.
  </p>
  <br>
  
  <p align="center" style="margin-bottom: 0px; margin-top: 10px;">
    <strong>§ 11 Number of Agreements</strong>
  </p>
  <p>The Agreement has been drawn up in two counterparts, one for each party.</p>
  <br>
  <br>
  
   <div>
    <p class="underline"><b>Attachments forming an integral part of the agreement:</b></p>
    <ol>
      <li class="underline">consent to the use of the image</li>
      <li class="underline">information clause GDPR</li>
      <li class="underline">authorization to process personal data</li>
      <li class="underline">information on the monitoring of classes on - line</li>
      <li class="underline">Contractor's statement</li>
      <li class="underline">Mandate copy</li>
    </ol>
  </div>
  
  <div class="cointainer" style="margin-top: 30px; margin-bottom: 30px;">
      <div class="left-cointainer">
          <p><b>{{ zamawiajacy }}</b></p>
      </div>
      <div class="right-cointainer">
          {{ imieNazwisko }}
          <br>
          <span style="margin-left: 0%;"><b>The Contractor</b></span>
      </div>
  </div>
  
   <div style="margin-top:5px;page-break-before: always;">
     <p class="underline">Attachment No.1</p>
     <p align="center" style="margin-top: 40px;"><strong>INFORMATION ON PROCESSING OF PERSONAL DATA INCLUDING IMAGES OF EMPLOYEES/CONTRACTORS</strong></p>
     <p>Tutore Poland Sp. z o.o. hereinafter referred to as the Company, intends to use the image of employees and contractors for marketing purposes, including placement on websites belonging to the Company's brands, placement in the Company's promotional materials (e.g. flyers, catalogs), placement in the Company's informational materials, placement on the pages of the Company's social media (including FB, Instagram) and within the framework of running video channels (Youtube). Under Article 6(1)(a) of the GDPR, the Company's processing of images of employees/contractors for the described marketing purposes requires the consent of the individuals whose data is processed.</p>
     <p align="center"><strong>INFORMATION CLAUSE  of Tutore Poland Sp. z o.o.</strong></p>
     <p>According to Articles 13 of Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of natural persons about the processing of personal data and the free movement of such data and the repeal of Directive 95/46/EC (General Data Protection Regulation), hereinafter GDPR, Below you will find information on the processing of personal data in the form of images of employees/contractors by Tutore Poland Sp. z o.o., hereinafter referred to as PDA:
      <ol>
        <li>the Administrator of Personal Data is Tutore Poland Sp. z o.o. with its registered office at Piotrkowska Street 157A, 90-440 Łódź, tel. 500 965 135</li>
        <li>PDA processes personal data in the form of images for marketing purposes as described in the Information on Processing of Personal Data involving the images of employees/contractors based on consent (Art. 6(1)(a) GDPR)</li>
        <li>Recipients of personal data may be entities providing IT and web support services and preparing campaigns and promotional materials (advertising agencies, interactive agencies), and press entities.</li>
        <li>PDA does not transfer personal data outside the European Economic Area.</li>
        <li>Personal data shall be kept for the period necessary for the purposes specified in point 2 or until the contractor withdraws consent.</li>
        <li>The person whose data is processed shall have the right to access his/her data and to receive a copy thereof, the right to rectify (amend) his/her data, the right to restrict processing, the right to be forgotten, the right to object, the right to data portability, the right to withdraw the granted consent at any time, the right to complain with the Office for Personal Data Protection.</li>
        <li>Provision of personal data is completely voluntary.</li>
        <li>There is no automated decision-making, including profiling, within the scope of PDA's activities, using the collected personal data.</li>
      </ol>
     </p>
  </div>
  
  <div class="container" style="page-break-before: always;">
      <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
        <tr>
          <td id="oswiadczenie">
            <p align="center" class="subheading"><strong>CONTRACTOR'S STATEMENT WITH CONSENT TO PROCESSING OF PERSONAL DATA</strong></p>
            <ol>
          <li>I the undersigned {{ imieNazwisko }} declare that:
          <ol type="a">
            <li>
              I have been acquainted with the Information on the processing of personal data including the image of employees/contractors and the Information Clause and acknowledge it,
            </li>
            <li>
              the content of the Information and Clause is understandable and clear to me, and any doubts have been explained to me by an authorized person from Tutore Poland Sp. z o.o., in a comprehensive manner,
            </li>
          </ol>
          </li>
          <li>in a completely voluntary manner, I agree to the processing of my personal data in the scope of my image for the marketing purposes described above.</li>
          <li>I have been informed that my personal data are processed on the basis of my expressed
            my voluntary consent and that I have the right to withdraw it at any time, whereby the withdrawal of consent shall have legal effect from the moment of its submission and shall not affect the processing of my personal data prior to the submission of the statement of withdrawal of consent.</li>
          <li>In accordance with Article 81 Paragraph 1 of the Act on Copyright and Related Rights, I agree to dissemination of my image by Tutore Poland Sp. z o.o., for marketing purposes described above.</li>
          </ol>
            <div class="right-cointainer" style="float: right; margin-top: 20px;">
              <span style="font-size: 14px;">{{ imieNazwisko }}</span>
              <br>
              <span><strong>legible signature of the Contractor</strong></span>
            </div>
        </td>
      </tr>
    </table>
    </div>
  
  <div style="page-break-before: always;">
    <p><strong>Attachment No 2</strong></p>
    <p align="center"><strong>INFORMATION ON PERSONAL DATA PROCESSING</strong></p>
    <ol>
    <li>I would like to inform you that the Administrator of your personal data as a Contractor is Tutore Poland Sp. z o.o. located at Piotrkowska Street 157A, 90-440 Łódź, KRS: 0000670834, NIP: 7272812193, tel. 500 965 135, info@tutore.eu.</li>
    <li>By providing you with this information on the processing of your personal data, the Administrator is complying with the legal obligation under Article 15(1) of Regulation (EU) 2016/679 of the European Parliament and of the Council of April 27, 2016, on the protection of natural persons about the processing of personal data and the free movement of such data and repealing Directive 95/46/EC (General Data Protection Regulation), hereinafter referred to as GDPR.</li>
    <li>The Administrator obtains information about you in connection with a statutory obligation, which is necessary for the effective implementation of the cooperation process. With regard to personal data not affected by the statutory condition of necessity - their provision is voluntary.</li>
    <li>Your personal data shall be processed for the following purposes, on the following basis and for the following period:
      <ol>
        <li>conclusion and execution of a civil contract - to fulfill the obligation under the Civil Code (Article 6(1)(b), (c), (f) GDPR) - for the period of cooperation,</li>
        <li>calculation and payment of remuneration - to fulfill the obligation under the Civil Code (Article 6(1)(c), Article 9(2)(b) GDPR) - for the period of cooperation,</li>
        <li>salary deductions – to fulfill salary enforcement obligations under the Civil Procedure Code, the Law on Administrative Enforcement Proceedings, and the Law on Bailiffs (Article 6(1)(c) of the DPA) - for the period designated by generally applicable laws,</li>
        <li>fulfillment of tax obligations – to fulfill the obligations of an income taxpayer under the Tax Ordinance, the Personal Income Tax Act, and other tax regulations (Article 6(1)(c) GDPR) - for a period of 5 years from the end of the calendar year,</li>
        <li>fulfillment of obligations towards the Social Insurance Institution – to fulfill obligations of a payer of social and health insurance contributions resulting from the Act on pensions from the Social Insurance Fund, the Act on the social insurance system, and the Act on health care benefits financed from public funds (Article 6.1.c, Article 9.2.b GDPR) - for a period of 5 years from the end of the calendar year,</li>
        <li>performance of accounting obligations – to fulfill obligations under the Accounting Act, the Tax Ordinance, and the Corporate Income Tax Act (Article 6(1)(c) GDPR) - for a period of 5 years from the end of the accounting year in which the event occurred,</li>
        <li>physical security of the Administrator's buildings, premises,s and property – based on the Administrator's legitimate interest (Article 6(1)(f) GDPR) - for the period of cooperation,</li>
        <li>to ensure the highest standards of service of lessons provided by Associates through the ClickMeeting or Zoom platform, the correctness of the performance of the entrusted activities and possible improvement of the quality of lessons, safeguarding the interests of the company in situations of disputes with the client (evidence) through monitoring and recording of online courses - based on the voluntary consent of the recorded person (Article 6(1)(a) RODO) - The image and voice of the Associate will be processed for a period of 3 months. If the recordings of the recorded classes constitute evidence in a proceeding conducted under the provisions of the law, or the Administrator becomes aware that they may constitute evidence in the proceeding, the period is extended until the legal conclusion of the proceedings. After the expiration of these periods, recordings containing personal data shall be destroyed</li>
        <li>to ensure that the recordings can be made available to new Employees and Associates
        recording of online training conducted via the Zoom platform - based on the voluntary consent of the person being recorded (Article 6(1)(a) of the RODO) - the Image and voice of the Associate will be processed until the consent is withdrawn. If the consent is withdrawn, the recordings containing personal data are subject to destruction,</li>
        <li>to ensure the highest standards of customer service quality, for training purposes - to improve the quality of service, to secure the interests of the company in situations of disputes with customers (evidence), to ensure the safety of Co-workers in case of undesirable and dangerous events on the part of customers (e.g. criminal threats) by monitoring telephone conversations with the Administrator's customers – based on the Administrator's legitimate interest (Article 6(1)(f) RODO) - for a period of up to 3 months. If the recordings of the recorded telephone conversations constitute evidence in a proceeding conducted based on the law, or the Administrator becomes aware that they may constitute evidence in the proceeding, this period is extended until the proceeding is legally concluded. After the expiration of these periods, recordings containing personal data shall be destroyed,</li>
        <li>creation of photo reports from camps for children and teenagers on a flash drive for Customers, Facebook fan page and Website www.musicandmore.pl - based on the voluntary consent of the recorded person (Article 6(1)(a) GDPR) - The image and voice of the Associate will be processed until the consent is withdrawn. If the consent is withdrawn, the recordings containing personal data shall be destroyed,</li>
        <li>pursuing or defending against claims – based on the Administrator's legitimate interest (Article 6(1)(f) GDPR) consisting in appearing in court cases - in the case of a pending proceeding for the duration of the proceeding until its conclusion and for the period designated by generally applicable laws.</li>
      </ol>
    </li>
    <li>The recipients of your personal data will be:
      <ol>
        <li>public administration bodies (e.g., Social Insurance Institutions, Tax Offices) - by relevant laws;</li>
        <li>health care institutions for occupational medicine purposes;</li>
        <li>external entities providing and supporting the Principal's ICT systems (both general ICT infrastructure, e-mail, and IT systems used by the Principal for HR and financial services or circulation of documents related to employment) - by relevant contracts of entrustment of personal data processing and ensuring that the above entities apply adequate technical and organizational measures to ensure data protection,</li>
        <li>accounting offices:</li>
        <li>banks – to pay salaries and other monetary benefits to the Principal in case they are paid with the consent of the Contractor to a bank account;</li>
        <li>contractors – to enable contractors (potential and current) to contact them or for ongtion of concluded agreements, and related to the Contractor's position;</li>
        <li>co-workers of the Principal who provide services to Tutore Poland Sp. z o.o., to enable co-workers to contact the Contractor,</li>
        <li>8entities providing additional services to Contractors, only if the Contractor uses these services.</li>
        <li>insurance institutions</li>
        <li>foreign administration organizations in the EU countries where the contract is implemented (applies to the implementation of the contract abroad)</li>
        <li>entities that train and perform health and safety duties (if there is no health and safety unit at the Principal)</li>
      </ol>
    </li>
    <li>You have the right to:
      <ol>
        <li>access to data - to obtain confirmation from the Administrator whether your personal data is being processed. If your data is processed, you are entitled to access it (Article 15 of the GDPR);</li>
        <li>receive a copy of the data - to obtain a copy of the data being processed, whereby the first copy is free of charge, and for subsequent copies, the relevant Administrator may impose a reasonable fee based on administrative costs (Article 15(3) GDPR);</li>
        <li>rectification - a request to correct personal data that is incorrect or to complete incomplete data (Article 16 GDPR);</li>
        <li>erasure - a request to delete personal data if the Administrator no longer has a legal basis for their processing or the data are no longer necessary for processing (Article 17 GDPR);</li>
        <li>restriction of processing - request for restriction of processing of personal data (Article 18 RODO), when:
          <ul>
            <li>you question the correctness of your personal data - for a period that allows the Administrator to verify the correctness of such data,</li>
            <li>the processing is unlawful, and you object to the deletion of the data by requesting a restriction of its use,</li>
            <li>The Administrator no longer needs the data, but they are yours to establish, assert or defend your or defense of claims;;</li>
            <li>you have objected to the processing - until it is determined whether the legitimate grounds on the part of the Administrator override the grounds for your objection;</li>
          </ul>
        </li>
        <li>data portability - to receive in a structured, commonly used machine-readable format personal data concerning you provided to the Administrator, and to request that such data be sent to another Administrator if the data are processed based on your consent, or a contract concluded with you and if the data are processed by automated means (Article 20 RODO);</li>
        <li>objection - to object to the processing of personal data for legitimate purposes of the Administrator, for reasons related to your particular situation, including against profiling. The Administrator shall assess the existence of valid legitimate grounds for the processing, overriding your interests, rights, and freedoms, or grounds for establishing, asserting, or defending claims. If according to the assessment, your interests override the interests of the Administrator, the Administrator will be obliged to stop processing data for these purposes (Article 21 of the DPA);</li>
        <li>the right to lodge a complaint to the supervisory authority - the President of the Office for Personal Data Protection, if you consider that the processing of personal data concerning you violates the law. Complaints can be submitted in the form of::
          <ul>
            <li>in writing to the address: 2 Stawki Street, 00-19Warsaw, </li>
            <li>electronically via the ePUAP platform.</li>
          </ul>
        </li>
      </ol>
    </li>
    <li>In the course of processing your personal data, there shall be no exclusively automated decision-making or profiling as referred to in Article 22 (1) and (4) of the RODO, which means that no decisions concerning you shall be made automatically and no profiles of you shall be created.</li>
    <li>You are obliged to inform the Principal of any changes concerning your personal data provided to the Principal under the Agreement.</li>
    </ol>
    </div>
  
    <p align="center" style="margin-top: 50px;"><strong>CONTRACTOR'S STATEMENT</strong></p>
    <ol>
      <li>I, the undersigned, declare that:
        <ol>
          <li>I have read the Information on the processing of my personal data and acknowledge it,</li>
          <li>the content of the Information is understandable and clear to me, and any doubts have been explained to me
            by an authorized person in a comprehensive manner.</li>
        </ol>
      </li>
    </ol>
    <div class="right-cointainer" style="float: right; margin-top: 20px;">
      <span style="font-size: 14px;">{{ imieNazwisko }}</span>
      <br>
      <span><strong>legible signature of the Contractor</strong></span>
    </div>
  
  <div style="page-break-before: always;">
    <div class="cointainer" style="margin-top: 60px;">
      <div class="left-cointainer">
        <p class="underline">Attachment No 3 authorization to process personal data</p>
      </div>
      <div class="right-cointainer">
        <p style="margin-bottom: 10px; font-size: 14px;">
      Łódź, {{ aktualnaData() }} r.
        </p>
      </div>
  </div>
    
    
  <p align="center" class="subheading" style="margin-bottom: 10px;">
    <strong>
      Authorization No. {{ nrUmowy }} to process personal data in the file in paper and electronic versions
    </strong>
  </p>
  <p class="p-margin">
    Under Article 29 of Regulation (EU) 2016/679 of the European Parliament and of the Council of April 27, 2016, on the protection of natural persons about the processing of personal data and the free movement of such data and repealing Directive 95/46/EC (General Data Protection Regulation), hereinafter referred to as GDPR, we hereby:
  </p>
  <p class="p-margin">
    as of {{ aktualnaData() }}
  </p>
  <p class="p-margin">
    I authorize your {{ imieNazwisko }} - Tutore Poland Sp. z o.o.
  </p>
  <p class="p-margin">
    employed as {{ rodzajUmowy }} in the department of
  </p>
  <p class="p-margin">
    to process the personal data contained in the following sets of personal data:
  </p>
    <ol type="a">
      <li>in electronic version:
        <ul>
          <li>
            a set of personal data of Participants: children, adolescents, and adults using services provided by Tutore Poland Ltd. - name and surname, class (if applicable), address of residence,
          </li>
          <li>
            personal data set of Customers: parents (legal guardians) of children, adolescents, and adults using services offered by Tutore Poland Sp. z o.o. - name and surname, address of residence, contact telephone, e-mail address
          </li>
        </ul>
      </li>
    </ol>
  <p class="p-margin">
    concerning the inspection, entry, modification, deletion, and archiving of personal data covered by the aforementioned collections.
  </p>
  <p class="p-margin">
    This authorization does not authorize further authorizations and expires on the date of termination of the employment relationship, and may be amended or revoked at any time.
  </p>
  <p>
    I obligate you to process the personal data contained in the aforementioned sets of personal data to the extent and in the manner required to fulfill your official duties to the Employer - Personal Data Administrator. I oblige you to process personal data under the authorization granted, by the Regulation of the European Parliament and the Council (EU)2016/679 of April 27, 2016, on the protection of natural persons through the processing of personal data and the free movement of such data and repealing Directive 95/46/EC ( Official Journal of the EU L 119, p.1) and the provisions of the Act of May 10, 2018, on the protection of personal data (Journal of Laws of 2018, item 1000) and applicable at Tutore Poland Sp. z o.o. Internal regulations on personal data protection.
    <br>
    Violation of the aforementioned duties may result in criminal liability and is grounds for termination of the employment contract.
  </p>
  
  <div class="container" style="page-break-before: always;">
      <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
        <tr>
          <td id="oswiadczenie">
            <p align="center" class="subheading"><strong>DECLARATION</strong></p>
            <ol>
          <li>I, the undersigned, declare that:
          <ol type="a">
            <li>
                I have read the contents and scope of the authorization and acknowledge them,
            </li>
            <li>
                the content of the authorization is understandable and clear to me, and any doubts have been explained to me by the authorized person in a comprehensive manner,
            </li>
            <li>I undertake to process personal data in accordance with the authorization granted, Rodo regulations and the Employer's internal procedures, including the Privacy Policy,</li>
            <li>I undertake to keep confidential the personal data to which I have or will have access in connection with the performance of duties for Tutore Poland Sp. z o.o., and to maintain the secrecy of the means of securing personal data, also after revocation or change of authorization, as well as after the end of the contract of mandate.</li>
            </ol>
          </li>
          </ol>
            <div class="right-cointainer" style="float: right; margin-top: 20px;">
              <span style="font-size: 14px;">{{ imieNazwisko }}</span>
              <br>
              <span><strong>legible signature</strong></span>
            </div>
        </td>
      </tr>
    </table>
    </div>
  
  <p class="subheading p-margin" style="text-align: center;">
    date and signature
    <br>
    <strong>{{ aktualnaData() }} - {{ imieNazwisko }}</strong>
  </p>
  <p class="subheading p-margin" style="text-align: center;">
    {{ zamawiajacy }}
    <br>
    <strong>on behalf of the Administrator</strong>
  </p>
  <br>
  <p>This authorization was revoked on the date of termination of the contract of assignment - i.e. until 31.08.2024</p>
  </div>
  
  <div style="page-break-before: always;">
    <p class="underline">Attachment No 5</p>
    <p class="subheading" style="margin-bottom: 0px;"><strong>Information about monitoring of classes online and recording of internal training on - line</strong></p>
    <br>
    <p>We would like to inform you that Tutore Poland Sp. z o.o. uses technical means for monitoring on - line classes and recording internal online training. Monitoring includes devices recording images and sound, which are used by the user to realize online classes i.e. Clickmeeting platform or Zoom application, and in case of internal training online Zoom application. Tutore Poland Sp. z o.o. uses monitoring for the following purposes: to ensure the highest standards of service of lessons realized by employees/contractors, the correctness of performance of entrusted activities and possible improvement of the quality of lessons, to protect the interests of the company in situations of disputes with the customer (evidence), and in the case of internal training on - line to ensure the possibility of making the recordings available to new employees/contractors. We inform you that: the audio-visual and audio monitoring system of online classes consists of a recording system of Clickmeeting or Zoom platform and server on which online classes are recorded, access to the records of online classes has persons authorized by the Management of Tutore Poland Sp. z o.o. i.e. Manager of the Call Center Department, Director of Process Management, Teamleader of the Call Center Department, persons who have access to the recorded image are aware of the responsibility for personal data protection and have appropriate authorization issued by the Administrator of personal data. In the course of the recording, processing of personal data in the form of voice, image, and name of the contractor conducting the class or training takes place. The Administrator of personal data obtained in the course of monitoring online classes and in the course of recording internal online training is Tutore Poland Sp. z o.o., which in connection with the above-described activity includes the required information clause regarding the processing of personal data below.

    </p>
    <br>
    <p><strong>Information clause of Tutore Poland Sp. z o.o. for employees/contractors in connection with the processing of personal data in the framework of monitoring online classes and recording internal online training</strong></p>
    <p>Under Article 13 of the Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of natural persons about the processing of personal data and the free movement of such data and repealing Directive 95/46/EC (General Data Protection Regulation), hereinafter RODO, Tutore Poland Sp. z o.o. informs:</p>
    <ol>
      <li>the Administrator of personal data is Tutore Poland Sp. z o.o. located at Piotrkowska Street 157A, 90-440 Łódź, tel. 500 965 135, info@tutore.eu, hereinafter referred to as PDA.</li>
      <li>PDA processes personal data for the purposes indicated in the information of monitoring classes on - line and recording internal training on - line - the legal basis for processing is the voluntary consent of the person being recorded (Article 6(1)(a) GDPR)</li>
      <li>PDA shall not transfer personal data outside the European Economic Area.</li>
      <li>Personal data will be stored for up to 3 months. If the recordings of online classes constitute evidence in a proceeding conducted based on the law or the ADO has become aware that they may constitute evidence in the proceeding, this period shall be extended until the legal conclusion of the proceeding. After the expiration of these periods, recordings containing personal data shall be destroyed.</li>
      <li>Recipients of personal data may be public authorities, judicial authorities, entities
        providing consulting services to ADO (in particular, legal consulting)).</li>
      <li>The person whose data are processed has the right to:
        <ol type="a">
          <li>access to their data and receive a copy of their data,</li>
          <li>the right to rectify (amend) your data,</li>
          <li>the right to limit processing,</li>
          <li>the right to be forgotten,</li>
          <li>the right to object,</li>
          <li>the right to data portability,</li>
          <li>the right to withdraw consent to the processing,</li>
          <li>right to file a complaint with the Office for Personal Data Protection.</li>
        </ol>
      </li>
      <li>The person whose data are processed shall be entitled to withdraw consent to the processing at any time, whereby the statement of withdrawal of consent shall affect its submission and shall not affect the processing of data before its submission.</li>
      <li>Provision of personal data within the scope of the clause is entirely voluntary but necessary for processing and the due performance of the agreement concluded by the parties.</li>
      <li>within the scope of ADO's activities, there is no automated decision-making, including profiling, using the collected personal data.</li>
    </ol>
  </div>
  
  <div class="container" style="page-break-before: always;">
      <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
        <tr>
          <td id="oswiadczenie">
            <p align="center" class="subheading"><strong>CONTRACTOR'S STATEMENT</strong></p>
            <ol>
          <li>I, the undersigned, declare that:
            <ol type="a">
              <li>
                I have read the Information on monitoring of classes on - line and recording of internal training on - line and the Information Clause and acknowledge it,
              </li>
              <li>
                the content of the Information and Clause is understandable and clear to me, and any doubts have been explained to me by an authorized person in a comprehensive manner,
              </li>
            </ol>
          </li>
          <li>On a completely voluntary basis, I consent to the processing of my personal data for the purposes indicated in the Information on monitoring of on - line classes and recording of internal on - line training.</li>
          <li>I have been informed that my personal data are processed on the basis of my expressed voluntary consent and that I have the right to withdraw it at any time, whereby the withdrawal of consent has legal effect from the moment of its submission and will not affect the processing of my personal data for purposes related to the implementation of the study prior to the submission of the statement of withdrawal of consent.</li>
          <li>In accordance with Article 81 paragraph 1 of the Act on Copyright and Related Rights I agree to dissemination of my image by Tutore Poland Sp. z o.o. for the purposes indicated in the Information about the monitoring of classes on - line and recording of internal training on - line.</li>
          </ol>
            <div class="right-cointainer" style="float: right; margin-top: 20px;">
              <span style="font-size: 14px;">{{ imieNazwisko }}</span>
              <br>
              <span><strong>legible signature of the Contractor</strong></span>
            </div>
        </td>
      </tr>
    </table>
    </div>


    </td>
    </tr>
    </tbody></table>   
</v-container>
</template>
  
  <script>
  export default {
    name: 'UmowaLektorB2BAngielski2024',
    data () {
      return {
        zamawiajacy: '',
        imieNazwisko: '',
        zamieszkany: '',
        korespondencyjny: '',
        pesel: '',
        nrRachunku: '',
        nrDowodu: '',
        nrTelefonu: '',
        email: '',
        emeryt: '',
        rencista: '',
        orzeczenieNiepelnosprawnosc: '',
        stopienNiepelnosprawnosc: '',
        student: '',
        jedenyTytulDoUbezpieczenia: '',
        chorobowe: '',
        zatrudnionyUmowaPraca: '',
        nazwaUmowaPraca: '',
        wynagrodzenieUmowaPraca: '',
        ubezpieczenieUmowaPraca: '',
        tytulUbezpieczenieUmowaPraca: '',
        umowaOd: '',
        umowaDo: '',
        urzadSkarbowy: '',
        nrUmowy: '',
        datapocz: '',
        datakon: '',
        wypo: '',
        kwotapokaz: '',
        slowniepokaz: '',
        shortUmowa: '',
        obywatelstwo: '',
        stawka1: '',
        stawka2: '',
        stawka3: '',
        nazwaFirmy: '',
        siedzibaFirmy: '',
        nip: '',
        kontoBankowe: '',
        rodzajUmowy: '',
        przedmiot: ''
      }
    },
    created () {
      Object.entries(this.$route.query).forEach(
        ([key, value]) => { this[key] = value }
      )
    },
    methods: {
      shortNrUmowy () {
        let tab = []
        let shortPosition = ''
        tab = this.nrUmowy.split('/')
        switch(tab[3]) {
          case 'Nauczyciel':
            shortPosition = 'Naucz'
            break;
          case 'Metodyk':
            shortPosition = 'Met'
            break
          case 'TworcaMaterialow':
            shortPosition = 'TMat'
            break
          case 'TworcaMaterialowNauczycielMetodyk':
            shortPosition = 'TMatNauMet'
            break
          case 'TworzenieProgramuNauczania':
            shortPosition = 'TPNau'
            break
          case 'AsystentOrganizacyjny':
            shortPosition = 'AOrg'
            break
          case 'MłodszyAsystentOrganizacyjny':
            shortPosition = 'MAOrg'
            break
          case 'TworzenieMap':
            shortPosition = 'TMapMC'
            break
          default:
            shortPosition = tab[3]
        }
        const shortUmowa = `${tab[0]}/${tab[1]}/${tab[2]}/${shortPosition}`
        return shortUmowa
      },
      slownieAngielski() {
        switch(this.kwota) {
          case '25':
            return 'twenty-five'
            break
          case '30':
            return 'thirty'
            break
          case '35':
            return 'thirty-five'
            break
          case '40':
            return 'forty'
            break
          case '45':
            return 'forty-five'
            break
          case '50':
            return 'fifty'
            break
          case '55':
            return 'fifty-five'
            break
          case '60':
            return 'sixty'
            break
          case '65':
            return 'sixty-five'
            break
          case '70':
            return 'seventy'
            break
          case '75':
            return 'seventy-five'
            break
          case '80':
            return 'eighty'
            break
          case '85':
            return 'eighty-five'
            break
          case '90':
            return 'ninety'
            break
          case '95':
            return 'ninety-five'
            break
          default:
            return this.slownie
        }
      },
      slowniePokazAngielski() {
        switch(this.kwotapokaz) {
          case '25':
            return 'twenty-five'
            break
          case '30':
            return 'thirty'
            break
          case '35':
            return 'thirty-five'
            break
          case '40':
            return 'forty'
            break
          case '45':
            return 'forty-five'
            break
          case '50':
            return 'fifty'
            break
          case '55':
            return 'fifty-five'
            break
          case '60':
            return 'sixty'
            break
          case '65':
            return 'sixty-five'
            break
          case '70':
            return 'seventy'
            break
          case '75':
            return 'seventy-five'
            break
          case '80':
            return 'eighty'
            break
          case '85':
            return 'eighty-five'
            break
          case '90':
            return 'ninety'
            break
          case '95':
            return 'ninety-five'
            break
          default:
            return this.slowniepokaz
        }
      },
      dataObowiazywaniaUmowy () {
        if (this.umowaOd === '' || this.umowaOd === '30-12-1899') {
          return 'dnia podpisania umowy przez obie strony'
        } else {
          return `${this.umowaOd} r.`
        }
      },
      zamawiajacyAngielski() {
        if (this.zamawiajacy === 'Marcin Grzelak - Prezes Zarządu') {
          return 'Marcin Grzelak - Chairman of the Board'
        } else {
          return this.zamawiajacy
        }
      },
      aktualnaData() {
        const today = new Date();
        let day = today.getDate();
        if((day+1) <= 10) {
          day = '0' + day
        }
        let month = today.getMonth()+1;
        if ((today.getMonth()+1) < 10) {
          month = '0' + month
        } 
        const todayDate = day+'-'+month+'-'+today.getFullYear()
        return todayDate
      }
    },
    mounted () {
      if (this.zamawiajacy) {
        this.$nextTick(() => {
          window.setTimeout(() => {
            const currentURL = window.location.href
            history.replaceState(history.state, '', '/')
            window.print()
            history.replaceState(history.state, '', currentURL)
          }, 300)
        })
      }
    }
  }
  </script>
  
  <style scoped>
  
  .page {
    size: 210mm 297mm;
    background-size: 100% 100%;
    line-height: 1.4;
    text-align: justify;
    margin-top: 2px;
    padding-top: 0px;
  }
  
  table {
    border: 1px;
    border-collapse: collapse;
    table-layout: fixed;
  }
  
  th, td {
    border: 1px;
    border-collapse: collapse;
  }
  
  .cointainer {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  
  .cointainer-left {
    width: 20%;
  }
  
  .right-cointainer {
    text-align: end;
  }
  
  thead {
    display: table-header-group;
  }
  
  .table-border {
    border: 1px solid black;
    border-collapse: collapse;
    padding: 5px;
  }
  
  .cell-in-first-table {
    margin-top: 2px;
    margin-bottom: 2px;
    margin-left: 10px;
    margin-right: 10px;
  }
  
  ul.dashed {
    list-style-type: "- ";
    margin: 0;
  }
  
  .underline {
    text-decoration: underline;
  }
  
  .pageNum {
    position: absolute;
    right: 0px;
    font-size: 14px;
  }
  
  #oswiadczenie {
    padding: 20px;
  }
  
  .p-margin {
    margin-bottom: 5px !important;
  }
  
  .attachments {
    width: 100%;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/UmowaLektorB2BAngielski2024.vue